import bus from './evbus';
import {Vue} from 'vue/types/vue';
import { AppErrorEnum } from './models/Enums';
import store from '@/store';
import { showPlanLimitsErrorInToast } from '@/services/constants/errors-without-toast.ts';
import { throttle, get } from 'lodash';
import BillingApi from '@/services/rest/bemob/billing';

const billingApi: BillingApi = new BillingApi();
export default (app: Vue) => {
  const onRateLimitExceededThrottled = throttle((error: any) => {
    const nextRetry = error.response.data.payload.seconds_to_wait_before_next_retry;
    bus.emit('toast-error', app.t('Exceeded number of requests. Please retry in {0} sec', [ nextRetry ]));
  }, 3000);

  bus.on('request-error', async (error: any)=>{
    const meta: any = error?.config?.meta || {};

    console.log(`%cError Handler (response) SHORT >>>> \nStatus: ${error?.response?.status} \nData: ${JSON.stringify(error?.response?.data)}`,
      'background: red; color: white');
    console.debug('Error Handler (response) FULL >>>>', error?.response);
    console.debug('Error Handler (application instance) >>>>', app);

    const { commit } = app.$store;

    commit('loading', false);

    //corruppted token issue fix
    if(error instanceof TypeError) {
      window.localStorage.removeItem('auth-token');
      store.commit('logout');
      app.$router.push('/logout');
    }

    if (meta.disconnectCheck && error.request.status === 0 && app.$store.state.isAuthenticated && app.$store.state.isAuthorized) {
      store.commit('isDisconnected', true);
    }

    if(error.message === 'Network Error' && !meta.disconnectCheck){
      return bus.emit('toast-error', app.t('The request failed. Please try again or contact the support team through live chat.'));
    }

    if(!error.response || meta.ignoreInterceptor) {
      return;
    }

    switch (error.response.status) {
      case 429:
        if (error.response.data.message === 'RATE_LIMIT_EXCEEDED') {
          onRateLimitExceededThrottled(error);
        }
        break;

      case 423:
        // @ts-ignore
        if (error.response.data.message === 'TWO_FACTOR_UNAUTHORIZED') {

          const twoFactorQrCode = get(error,'response.data.payload.twoFactorQrCode');
          if(twoFactorQrCode){
            store.commit('member', {twoFactorQrCode});
          }

          commit('secondFactorAuth', false);
          app.$router.push('/two-factor');
        }
        break;

      case 401:
        if(error.request.responseURL.toLowerCase().indexOf('auth/login/member') === -1 && error.request.responseURL.toLowerCase().indexOf('auth/login/support') === -1) {
          if (error.response.data.message === 'UNAUTHORIZED') {
            window.localStorage.removeItem('auth-token');
            store.commit('logout');
            app.$router.push('/logout');
            bus.emit('toast-error', (app as any).t(error.response.data.message));
          }
        }
        
        break;

      case 402:
        switch (error.response.data.message) {
          case AppErrorEnum.freePlanLimitsExceeded:
              store.commit('appError', error.response.data.message);
              break;
          case AppErrorEnum.unpaidInvoices:
            store.commit('appError', error.response.data.message);
            break;
          case AppErrorEnum.dataRetentionTooOldDataRetrieved:
            bus.emit('open-dialog',{
              name: 'ChangePlanDialog',
              data: {
                planLimits: 'dataRetention',
              }
            });
            break;
          case AppErrorEnum.billingPaymentMethodVerificationFailed:
            store.commit('appError', error.response.data.message);
            break;
          default:
            bus.emit('toast-error', (app as any).t(error.response.data.message));
            break;
        }
        break;

      case 409:
        if (error.response.data.subscriptionRestriction){
          await billingApi.getSubscriptions();
          if(showPlanLimitsErrorInToast(error)){
            bus.emit('toast-error', (app as any).t(error.response.data.message));
          }
        }
        break;
      case 403:
      case 400:
      case 500:
        if (Array.isArray(error.response.data.errors) && error.response.data.errors.length > 0) {
          const textError = error.response.data.errors.map(({ keys, error }) => (app as any).t(error, keys)).join('<br>')
          bus.emit('toast-error', textError);
        } else {
          if(error?.response?.data?.message){
            bus.emit('toast-error', (app as any).t(error?.response?.data?.message));
          }
        }
        break;
    }

  })

}
